<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <div class="copyright">
        &copy; {{ year }}, Stormhaven Studios LLC
      </div>
    </div>
    <div style="text-align:center;">Stormhaven Studios® and Embers Adrift® are registered trademarks of Stormhaven Studios, LLC. All Rights Reserved</div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
